module.exports = __webpack_public_path__ + "src/assets/images/full-screen-50.15d0e2599ce88fb1383be501f9e8c07e.png";